"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartIdentifierTag = void 0;
exports.isSectionGroupPartIdentifier = isSectionGroupPartIdentifier;
exports.isSectionPartIdentifier = isSectionPartIdentifier;
exports.isSubsectionPartIdentifier = isSubsectionPartIdentifier;
exports.isFieldGroupPartIdentifier = isFieldGroupPartIdentifier;
exports.isFieldPartIdentifier = isFieldPartIdentifier;
exports.isSelectOptionPartIdentifier = isSelectOptionPartIdentifier;
var PartIdentifierTag;
(function (PartIdentifierTag) {
    PartIdentifierTag["sectionGroup"] = "sectionGroup";
    PartIdentifierTag["section"] = "section";
    PartIdentifierTag["subsection"] = "subsection";
    PartIdentifierTag["fieldGroup"] = "fieldGroup";
    PartIdentifierTag["field"] = "field";
    PartIdentifierTag["selectOption"] = "selectOption";
})(PartIdentifierTag || (exports.PartIdentifierTag = PartIdentifierTag = {}));
function isSectionGroupPartIdentifier(partIdentifier) {
    return !!partIdentifier && partIdentifier.tag === 'sectionGroup';
}
function isSectionPartIdentifier(partIdentifier) {
    return !!partIdentifier && partIdentifier.tag === 'section';
}
function isSubsectionPartIdentifier(partIdentifier) {
    return !!partIdentifier && partIdentifier.tag === 'subsection';
}
function isFieldGroupPartIdentifier(partIdentifier) {
    return !!partIdentifier && partIdentifier.tag === 'fieldGroup';
}
function isFieldPartIdentifier(partIdentifier) {
    return !!partIdentifier && partIdentifier.tag === 'field';
}
function isSelectOptionPartIdentifier(partIdentifier) {
    return !!partIdentifier && partIdentifier.tag === 'selectOption';
}
